// UpdateBanner.js
// Aviso global de "hay una versión nueva de la app" (updateNotifier.js lo
// activa cuando detecta que el service worker ha cambiado de versión).
// Nunca recarga sola: el usuario decide cuándo, con el botón "Actualizar".
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { subscribe, actualizarAhora, descartarAviso } from "../api/updateNotifier";

// En mitad de una compra no se ofrece actualizar (recargar ahí, con el catálogo aún
// cargando, es lo que dejó vacío el carrito de una supervisora): el aviso espera y
// sale en cuanto se sale de estas pantallas.
const EN_COMPRA = /^\/(supervisora\/(crearCompras|carrito|pisoCrearCompras|modificarVerCompras)|comprador\/(detalleCompra|ordenarCompra))/i;

const UpdateBanner = () => {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => subscribe(setVisible), []);

  if (!visible || EN_COMPRA.test(pathname)) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9998,
        background: "linear-gradient(135deg,#1e293b,#0f172a)",
        color: "#fff",
        padding: "10px 16px",
        paddingTop: "calc(10px + env(safe-area-inset-top, 0px))",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        flexWrap: "wrap",
        fontSize: 13.5,
        fontWeight: 700,
        boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
      }}
    >
      <span>🔄 Hay una versión nueva de la app disponible</span>
      <button
        onClick={actualizarAhora}
        style={{
          background: "#fff",
          color: "#1e293b",
          border: "none",
          borderRadius: 8,
          padding: "6px 16px",
          fontWeight: 800,
          fontSize: 13,
          cursor: "pointer",
        }}
      >
        Actualizar
      </button>
      <button
        onClick={descartarAviso}
        style={{
          background: "none",
          border: "none",
          color: "#cbd5e1",
          fontSize: 12.5,
          cursor: "pointer",
          textDecoration: "underline",
        }}
      >
        Ahora no
      </button>
    </div>
  );
};

export default UpdateBanner;
